import { Grid } from '@mui/material';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
const PreviewAttachmentBox = ({ item, handleDelete }) => {
    return (
        <Grid item sx={{ mb: 0.5 }} md={4}>
            <div className="thumbnail">
                <button type="button" className="cross" onClick={() => handleDelete()}>
                    <CloseOutlinedIcon />
                </button>
                <div className="thumbnail-wrapper">
                    {item && (item.type == 'image/png' || item.type == 'image/jpg' || item.type == 'image/jpeg') && (
                        <div className="thumbnail-inner">
                            <img src={URL.createObjectURL(item)} alt="new" />
                        </div>
                    )}
                    {item && item.type == 'application/pdf' && (
                        <div className="thumbnail-inner bg-gray">
                            <PictureAsPdfOutlinedIcon />
                        </div>
                    )}
                    {item && item.name && <div className="thumbnail-title">{item.name}</div>}
                </div>
            </div>
        </Grid>
    );
};
export default PreviewAttachmentBox;
